import { isDate as Nt } from "../../util/code-utils.js";
import {
  convertMsToSeconds as l,
  dateFromUnixTimestamp as h,
  secondsAgo as Qt,
  secondsInTheFuture as Wt
} from "../../util/date-utils.js";
export default class Vt {
  constructor(t, s, e, i) {
    (this.Hl = t),
      (this.Ql = s),
      (this.comparator = e),
      (this.Xl = i),
      this.Ql === Vt.Kl.Vl &&
        this.comparator !== Vt.Yl.Wl &&
        this.comparator !== Vt.Yl.Zl &&
        this.comparator !== Vt.Yl.Uh &&
        this.comparator !== Vt.Yl.Qh &&
        (this.Xl = h(this.Xl));
  }
  Jl(t) {
    let s = null;
    switch ((null != t && (s = t[this.Hl]), this.comparator)) {
      case Vt.Yl.Xh:
        return null != s && s.valueOf() === this.Xl.valueOf();
      case Vt.Yl.Vh:
        return null == s || s.valueOf() !== this.Xl.valueOf();
      case Vt.Yl.Kh:
        return typeof s == typeof this.Xl && s > this.Xl;
      case Vt.Yl.Wl:
        return this.Ql === Vt.Kl.Vl
          ? null != s && Nt(s) && Qt(s) <= this.Xl
          : typeof s == typeof this.Xl && s >= this.Xl;
      case Vt.Yl.Yh:
        return typeof s == typeof this.Xl && s < this.Xl;
      case Vt.Yl.Zl:
        return this.Ql === Vt.Kl.Vl
          ? null != s && Nt(s) && Qt(s) >= this.Xl
          : typeof s == typeof this.Xl && s <= this.Xl;
      case Vt.Yl.Zh:
        return (
          null != s &&
          "string" == typeof s &&
          typeof s == typeof this.Xl &&
          null != s.match(this.Xl)
        );
      case Vt.Yl.$h:
        return null != s;
      case Vt.Yl.Eu:
        return null == s;
      case Vt.Yl.Uh:
        return null != s && Nt(s) && Wt(s) < this.Xl;
      case Vt.Yl.Qh:
        return null != s && Nt(s) && Wt(s) > this.Xl;
      case Vt.Yl.au:
        return (
          null == s ||
          typeof s != typeof this.Xl ||
          "string" != typeof s ||
          null == s.match(this.Xl)
        );
    }
    return !1;
  }
  static fromJson(t) {
    return new Vt(
      t.property_key,
      t.property_type,
      t.comparator,
      t.property_value
    );
  }
  ss() {
    let t = this.Xl;
    return (
      Nt(this.Xl) && (t = l(t.valueOf())),
      { k: this.Hl, t: this.Ql, c: this.comparator, v: t }
    );
  }
  static Pn(t) {
    return new Vt(t.k, t.t, t.c, t.v);
  }
}
(Vt.Yl = {
  Xh: 1,
  Vh: 2,
  Kh: 3,
  Wl: 4,
  Yh: 5,
  Zl: 6,
  Zh: 10,
  $h: 11,
  Eu: 12,
  Uh: 15,
  Qh: 16,
  au: 17
}),
  (Vt.Kl = { Tu: "boolean", Au: "number", _u: "string", Vl: "date" });
